export const environment = {
  production: false,
  siteURL: "https://cdl-insuretec.herokuapp.com/",
  logURL: "https://convertion-tracking.herokuapp.com/",
  paymentUrl: "https://proxy-uat.businessinsurancesolutions.co.uk"
};
